import React, { useState } from "react";
import img1 from "../../../Assets/About/img1.png";
import img2 from "../../../Assets/About/img2.png";
import img3 from "../../../Assets/About/img3.png";
import img4 from "../../../Assets/About/img4.png";
import img5 from "../../../Assets/About/img5.png";

const Body = () => {
  const [activeButton, setActiveButton] = useState("The Why");
  return (
    <div className="m-8 md:m-16">
      {/* Button  */}
      <div className="flex justify-between md:justify-center  items-center">
        <button
          onClick={() => setActiveButton("The Why")}
          className={`whitespace-nowrap px-6 w-full md:w-auto md:px-10 py-3 border transition-all ease-in-out duration-300  font-medium ${
            activeButton === "The Why"
              ? "bg-[#235784] text-white border-[#235784]"
              : "border-[#E7E7E7] text-[#235784]"
          }  rounded-l-full`}
        >
          The Why
        </button>
        <button
          className={`transition-all whitespace-nowrap w-full md:w-auto ease-in-out duration-300 font-medium px-6 md:px-10 py-3 border ${
            activeButton === "The What"
              ? "bg-[#235784] text-white border-[#235784]"
              : "border-[#E7E7E7] text-[#235784]"
          }  rounded-r-full`}
          onClick={() => setActiveButton("The What")}
        >
          The What
        </button>
      </div>

      {/* Products  */}
      {activeButton === "The Why" && (
        <div>
          <div className="flex flex-col lg:flex-row justify-between items-center gap-8 xl:gap-24 my-4">
            <div className="w-full lg:w-[50%]" data-aos="fade-right">
              <h1 className="text-2xl xl:text-3xl text-[#235784] tracking-wide font-bold mb-1">
                Products
              </h1>
              <p className="text-[#62B6FF] mb-4">
                A place that feels like you.
              </p>
              <p className="w-full xl:w-[70%] leading-relaxed mb-2 xl:text-lg">
                A Place That Feels Like You. At Yostel, you're not just walking
                into walls and doors — you're stepping into warmth, into
                belonging. We take the weight of chores off your hands and put
                comfort in their place. Here, your dreams have room to grow, and
                your tribe is just a heartbeat away.
              </p>
            </div>
            <img
              src={img1}
              alt=""
              className="w-full lg:w-[50%]"
              data-aos="fade-left"
            />
          </div>

          {/* Amenities  */}
          <div className="flex flex-col lg:flex-row justify-between items-center gap-8 xl:gap-24 my-4">
            <img
              src={img2}
              alt=""
              className="w-full lg:w-[50%]"
              data-aos="fade-right"
            />

            <div className="w-full lg:w-[50%]" data-aos="fade-left">
              <h1 className="text-2xl xl:text-3xl text-[#235784] tracking-wide font-bold mb-1">
                Amenities
              </h1>
              <p className="text-[#62B6FF] mb-4">
                Freedom to live, not just survive.
              </p>
              <p className="w-full xl:w-[70%] leading-relaxed mb-2 xl:text-lg">
                You weren't made to get stuck doing dishes or decoding laundry
                cycles. You were made to create, to explore, to become. At
                Yostel, we carry the everyday burdens, so your days are lighter,
                your laughter louder, and your journey freer.
              </p>
            </div>
          </div>

          {/* Community  */}
          <div className="flex flex-col lg:flex-row justify-between items-center gap-8 xl:gap-24 my-4">
            <div className="w-full lg:w-[50%]" data-aos="fade-right">
              <h1 className="text-2xl xl:text-3xl text-[#235784] tracking-wide font-bold mb-1">
                Community
              </h1>
              <p className="text-[#62B6FF] mb-4">A Family you choose.</p>
              <p className="w-full xl:w-[70%] leading-relaxed mb-2 xl:text-lg">
                Some bonds aren't made by blood — they're built in shared
                moments, late-night talks, and dreams whispered across rooms. At
                Yostel, you find not just friends but companions for your
                journey — people who stay in your story long after you move on.
              </p>
            </div>
            <img
              src={img3}
              alt=""
              className="w-full lg:w-[50%]"
              data-aos="fade-left"
            />
          </div>

          {/* Technology  */}
          <div className="flex flex-col lg:flex-row justify-between items-center gap-8 xl:gap-24 my-4">
            <img
              src={img4}
              alt=""
              className="w-full lg:w-[50%]"
              data-aos="fade-right"
            />
            <div className="w-full lg:w-[50%]" data-aos="fade-left">
              <h1 className="text-2xl xl:text-3xl text-[#235784] tracking-wide font-bold mb-1">
                Technology
              </h1>
              <p className="text-[#62B6FF] mb-4">The Future, in Your Palm.</p>
              <p className="w-full xl:w-[70%] leading-relaxed mb-2 xl:text-lg">
                Yostel lives where you do — in the rhythm of your life, in the
                device you trust every day. From moving in to making memories,
                our app keeps everything flowing with ease. Because here, we
                don’t just give you a space — we give you a smarter, sweeter way
                to live..
              </p>
            </div>
          </div>
        </div>
      )}

      {activeButton === "The What" && (
        <div className="flex flex-col items-center justify-center my-4">
          <div
            data-aos="zoom-in"
            className="flex flex-col items-center justify-center"
          >
            <h1
              className="text-xl font-bold tracking-wide text-center text-[#235784] mb-6"
              data-aos=""
            >
              We didn’t just build a hostel - we built a home.
            </h1>
            <p className="text-[#4A4A4A] text-center w-full xl:w-[70%] mb-4 tracking-wide ">
              Born from our own search for comfort and belonging, Yostel is a
              community where dreams grow, friendships blossom, and every corner
              feels like it’s yours. Designed by those who understand you.
              Inspired by those who live it — you.
            </p>
          </div>
          <img src={img5} alt="" data-aos="flip-up" />
        </div>
      )}
    </div>
  );
};
export default Body;
